module.exports = __webpack_public_path__ + "img/07_02.00619e72.jpg";